/* Syntax compiled to ES2018; source and reproducible build: docs/analysis/2026-11-02-clarity-fixes. */
(() => {
  const drawer = document.querySelector("cart-drawer");
  const access = document.querySelector(".sp-cart-access");
  if (!drawer || !access) return;
  let state;
  const money = (value) => (value / 100).toLocaleString("pl-PL", { style: "currency", currency: "PLN" });
  function sync() {
    const source = drawer.querySelector("[data-sp-cart-state]");
    if (!source) return;
    try {
      state = JSON.parse(source.textContent);
    } catch (_) {
      return;
    }
    drawer.classList.toggle("is-empty", state.item_count === 0);
    access.hidden = state.item_count === 0;
    const count = access.querySelector("[data-sp-cart-count]");
    const label = `(${state.item_count})`;
    if (count.textContent !== label) count.textContent = label;
    access.setAttribute("aria-label", `Otwórz koszyk, liczba produktów: ${state.item_count}`);
    updateSticky();
    drawer.querySelectorAll("[data-sp-offer-price]").forEach((el) => {
      var _a;
      const quote = (_a = window.SPCartPricing) == null ? void 0 : _a.quote(state, Number(el.dataset.spOfferPrice));
      const text = quote ? `Dopłata: ${money(quote.delta)}` : `${money(Number(el.dataset.spOfferPrice))} przed rabatem`;
      if (el.textContent !== text) el.textContent = text;
    });
    positionAccess();
  }
  function updateSticky() {
    const button = document.querySelector(".sp-stickyatc__btn");
    if (!button || button.disabled || !state) return;
    const form = button.closest("form");
    const id = Number(form.elements.id.value);
    const qty = Number(form.elements.quantity.value);
    const present = state.items.filter((item) => item.id === id).reduce((sum, item) => sum + item.quantity, 0) >= qty;
    const label = present ? `Zobacz koszyk (${state.item_count})` : "Dodaj do koszyka";
    button.dataset.spViewCart = present ? "true" : "false";
    if (button.textContent !== label) button.textContent = label;
    button.setAttribute("aria-haspopup", present ? "dialog" : "false");
  }
  function positionAccess() {
    let lift = 0;
    document.querySelectorAll(".sp-stickyatc.is-visible, .sp-lista__sticky.is-on").forEach((el) => {
      if (getComputedStyle(el).display !== "none") lift = Math.max(lift, el.offsetHeight);
    });
    access.style.setProperty("--sp-cart-lift", `${lift}px`);
    const sticky = document.querySelector('.sp-stickyatc.is-visible .sp-stickyatc__btn[data-sp-view-cart="true"]');
    access.classList.toggle("sp-cart-access--duplicate", Boolean(sticky && getComputedStyle(sticky.closest(".sp-stickyatc")).display !== "none"));
  }
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest('[data-sp-cart-open], .sp-stickyatc__btn[data-sp-view-cart="true"]');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      drawer.open(trigger);
      return;
    }
    if (event.target.closest(".sp-pdp__atc, .sp-stickyatc__btn, [data-sp-upsell-add], cart-remove-button, .quantity__button")) drawer.cancelRefresh();
  }, true);
  document.addEventListener("change", (event) => {
    if (event.target.closest("cart-drawer-items")) drawer.cancelRefresh();
  }, true);
  document.addEventListener("sp:cart-updated", sync);
  document.addEventListener("sp:selection-updated", () => {
    updateSticky();
    positionAccess();
  });
  new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  document.querySelectorAll(".sp-stickyatc, .sp-lista__sticky").forEach((el) => {
    new MutationObserver(positionAccess).observe(el, { attributes: true, attributeFilter: ["class"] });
    new ResizeObserver(positionAccess).observe(el);
  });
  window.addEventListener("resize", positionAccess, { passive: true });
  const refresh = () => {
    if (drawer.classList.contains("active") || document.documentElement.classList.contains("sp-cart-loading")) return;
    return drawer.refreshContents().catch(() => {
    });
  };
  window.addEventListener("pageshow", refresh);
  window.addEventListener("pagehide", () => drawer.close());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && !drawer.classList.contains("active")) refresh();
  });
  sync();
})();
